export const optionsArray = [
  "Okirika",
  "Fabrics",
  "Computers",
  "Auto parts",
  "Groceries",
  "Leather goods",
  "Building materials",
  "Vehicles",
  "Medical",
  "Education",
  "Legal",
  "Information Technology",
  "Maintenance",
  "Financial",
  "Hospitality",
];
